(function ($) {
    $('.js-read-more').on('click', function (evt, elm) {
        $(this).hide();
        $(this).parent().siblings('.js-additional-content').slideDown('fast');
        return false;
    });

    $('.js-see-less').on('click', function (evt, elm) {
        // $(this).hide();
        $(this).closest('.js-content-expansion').find('.read-more').show();
        $(this).closest('.js-additional-content').slideUp('fast');
        return false;
    });
}(jQuery));